<template>
  <div>
    <p>{{ drug.title }}</p>
    <p v-if="+drug.pack_set !== 1">Препарат комплектный: <span
      class="badge badge-info">1 комплект</span> -
      <strong>{{ drug.pack_set }}</strong>
      (зав.уп.)</p>
    <p v-if="drug.cool"><span class="icon icon-snowflake"></span> необходим хладогент</p>
<!--    <p class="pack_comment" v-if="drug.pack_comment">{{ drug.pack_comment }}</p>-->
    <p class="pack_box_comment" v-if="drug.pack_box_comment">
      {{ drug.pack_box_comment }}</p>
  </div>
</template>

<script>

export default {
  props: ['drug']
}

</script>

<style scoped>
p {
  margin-bottom: 1px;
}

.icon {
  display: inline-block;
  vertical-align: sub;
}

.pack_comment {
  font-size: 12px;
  color: #3bb3d8;
}

.pack_box_comment {
  font-size: 12px;
  color: #6c757d;
}
</style>
